import { Injectable } from '@angular/core';
import md5 from 'md5';
import { NotifyService } from '../notify/notify.service';
import { TranslateService } from '../translate/translate.service';
@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  handle = {
    error: (err: any) => {
      if (typeof (err) === 'string') {
        this.notifyService.notify.warning(err);
      } else if (typeof (err) === 'object') {
        let message = err.error || err.message || err.ExceptionMessage || err.Message || 'UNKNOWN ERROR';
        if (typeof (err.json) === 'function') {
          err = err.json();
          if (err) {
            message = err.error || err.message || err.ExceptionMessage || err.Message || 'UNKNOWN ERROR';
          }
        }
        this.notifyService.notify.warning(message);
      } else {
        console.error(err);
        this.notifyService.notify.warning('UNKNOWN ERROR');
      }
    }
  };

  constructor(
    private notifyService: NotifyService,
    private translateService: TranslateService) { }

  hashMD5 = (key: string) => md5(key);

  arrayToObject = <T>(items: T[], key: string): { [key: string]: T } => {
    return items.reduce((obj, item) => { obj[item[key]] = item; return obj; }, {});
  }

  changeAliasLowerCase(alias: string) {
    let str = alias || '';
    str = str.toString().toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, ' ');
    str = str.replace(/ + /g, ' ');
    str = str.trim();
    return str;
  }

  timeDifference = (previous: any, current: any = new Date()) => {
    if (!Date.isDate(previous)) {
      return '';
    }
    if (!Date.isDate(current)) {
      return '';
    }
    const { translate } = this.translateService;
    const from = new Date(previous);
    const to = new Date(current);
    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;
    const msPerMonth = msPerDay * 30;
    const msPerYear = msPerDay * 365;
    const elapsed = to.getTime() - from.getTime();

    if (elapsed < msPerMinute) {
      return `${Math.round(elapsed / 1000)} ${translate('seconds ago')}`;
    }

    if (elapsed < msPerHour) {
      return `${Math.round(elapsed / msPerMinute)} ${translate('minutes ago')}`;
    }

    if (elapsed < msPerDay) {
      return `${Math.round(elapsed / msPerHour)} ${translate('hours ago')}`;
    }

    if (elapsed < msPerMonth) {
      return `${Math.round(elapsed / msPerDay)} ${translate('days ago')}`;
    }

    if (elapsed < msPerYear) {
      return `${Math.round(elapsed / msPerMonth)} ${translate('months ago')}`;
    }
    return `${Math.round(elapsed / msPerYear)} ${translate('years ago')}`;
  }
}
